import { ApiErrorResponse } from "../../../../types/ApiErrorResponse";
import { uploadServiceIndicatorsCsv, getServiceIndicators } from "../api/serviceIndicators";
import GenericDictionaryPage from "./GenericDictionaryPage";

export default function ServiceIndicators() {
    return (
        <GenericDictionaryPage
            tableKey="serviceIndicators"
            fetchData={getServiceIndicators}
            titleKey="genericDic:serviceIndicators"
            hasCode={true}
            newButtonLabel={({ t }) =>
                t("genericDic:claimReopenReasonButtonNew", {
                    tableName: t("genericDic:serviceIndicatorsTitleNewButton")
                })
            }
            csvUpload={{
                modalTitleKey: "common:csv.importCsvTitle",
                modalSubtitleKey: "common:csv.selectFile",
                onUpload: async ({ file, closeModal, refetchData, showAlert, t }) => {
                    try {
                        const result = await uploadServiceIndicatorsCsv(file);

                        if (result.errors && result.errors.length > 0) {
                            showAlert({
                                message: t("common:csv.invalidCsvFormat"),
                                type: "danger",
                                duration: 10000
                            });
                            closeModal();
                            return;
                        }

                        if (result.imported === 0) {
                            showAlert({
                                message: t("common:csv.importNoNewData"),
                                type: "danger",
                                duration: 8000
                            });
                            closeModal();
                            return;
                        }

                        showAlert({
                            message: t("common:csv.importSuccess", { countValues: result.imported }),
                            type: "success",
                            duration: 8000
                        });

                        closeModal();
                        await refetchData();
                    } catch (error) {
                        const fetchError = error as ApiErrorResponse;
                        closeModal();
                        showAlert({
                            message: fetchError?.message?.toString() ?? t("user:modal.messageDeleteUserError"),
                            type: "danger",
                            duration: 8000
                        });
                    }
                }
            }}
        />
    );
}


